define('tracks/video-time',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parseTime = void 0;
    /**
     * Parse a time string into seconds
     * 139.0
     * 2m13
     * 2m13s
     * 2:13
     */
    function parseTime(timeString) {
        if (!timeString) {
            return 0;
        }
        else if (timeString.match(/^\d*(\.\d+)?$/)) {
            return Number(timeString);
        }
        else if (timeString.match(/^(\d+)m(\d+)s?$/)) {
            var _a = timeString.match(/^(\d+)m(\d+)s?$/), _ = _a[0], min = _a[1], sec = _a[2];
            return 60 * Number(min) + Number(sec);
        }
        else if (timeString.match(/^(\d+):(\d\d)$/)) {
            var _b = timeString.match(/^(\d+):(\d\d)$/), _ = _b[0], min = _b[1], sec = _b[2];
            return 60 * Number(min) + Number(sec);
        }
        else {
            // Failed to parse
            return NaN;
        }
    }
    exports.parseTime = parseTime;
});
//# sourceMappingURL=/assets/javascripts/tracks/video-time.js.map;
